import React, { useEffect } from "react";
import { clearBalances, getBalances } from "../../store/global/getBalances";
import { GlobalStore } from "../../store/global/GlobalStore";
import { Config, WagmiConfig } from "wagmi";
import { bootstrapWagmi } from "../../utils/bootstrapWagmi";
import { SUPPORTED_CHAINS } from "../../config/chains";
import "@rainbow-me/rainbowkit/styles.css";
import { RainbowKitProvider } from "@rainbow-me/rainbowkit";
import { Disclaimer } from "./Discalimer";
import { useBebopTheme } from "../../hooks/useBebopTheme";
import { getPermit2Allowances } from "../../store/global/getPermit2Allowance";
import { useTokenListByChain } from "hooks/useTokenListByChain";
import { processNetworkFromUrl, URL_KEYS } from "../../utils/urlUtils";

export interface Web3Props {
  children: React.ReactNode;
}

export const wagmiConfig: Config = bootstrapWagmi();
export const Web3: React.FC<Web3Props> = ({ children }) => {
  const bebopTheme = useBebopTheme();
  const address = GlobalStore.useState(s => s.address);
  const network = GlobalStore.useState(s => s.network);
  const tokenList = useTokenListByChain();
  const params = new URL(window.location as unknown as string).searchParams;
  const urlNetwork = params.get(URL_KEYS.NETWORK);

  /**
   * Load token balances after wallet is connected
   */
  useEffect(() => {
    if (address && tokenList != null) {
      void getBalances
        .run({ address: address as `0x${string}`, tokenList, chain: network })
        .then(res => {
          if (!res.error) {
            console.warn("Balances", res.payload);
          }
        })
        .catch(err => {
          console.error(err);
        });
      void getPermit2Allowances.run({ address: address as `0x${string}`, tokenList }).then(res => {
        if (!res.error) {
          console.log(`Allowances`, res.payload);
        }
      });
      void getPermit2Allowances.run({ address: address as `0x${string}`, tokenList }).then(res => {
        if (!res.error) {
          console.log(`Permit2 Allowances`, res.payload);
        }
      });
    } else {
      clearBalances();
    }
  }, [address, network, tokenList]);

  return (
    <WagmiConfig config={wagmiConfig}>
      <RainbowKitProvider
        chains={SUPPORTED_CHAINS}
        theme={bebopTheme}
        appInfo={{
          disclaimer: Disclaimer,
        }}
        initialChain={processNetworkFromUrl(urlNetwork) ?? SUPPORTED_CHAINS[0]}
      >
        {children}
      </RainbowKitProvider>
    </WagmiConfig>
  );
};
